import { RoutingSymfony } from '../../player/mobile/helpers/routing';
import RequestBuilder, {
    ErrorHandler,
    Significance,
} from '../../helpers/Request/Builder/RequestBuilder';
import type { PermissionsResponse } from '../../../vue/stores/permissions';
import { ResponsePermissionsC } from '../../../vue/stores/permissions';
import type { UserDetails } from '@/vue/stores/user';
import { UserDetailsC } from '@/vue/stores/user';
import type { GlobalSettings } from '@/vue/stores/globalSettings';
import { GlobalSettingsC } from '@/vue/stores/globalSettings';

const APP_ROUTE = {
    PERMISSIONS: 'api_get_all_rights',
    USER_DETAILS: 'api_user_details',
    GLOBAL_SETTINGS: 'api_global_settings',
} as const;

class AppApi {
    public async getPermissions(): Promise<PermissionsResponse> {
        const url = RoutingSymfony.generate(APP_ROUTE.PERMISSIONS);
        return new RequestBuilder(ResponsePermissionsC)
            .setUrl(url)
            .allow403()
            .setErrorHandler(ErrorHandler.None)
            .setSignificance(Significance.Invisible)
            .setMethod('GET')
            .build()
            .send();
    }

    public async getUserDetails(): Promise<UserDetails> {
        const url = RoutingSymfony.generate(APP_ROUTE.USER_DETAILS);
        return new RequestBuilder(UserDetailsC)
            .setUrl(url)
            .allow403()
            .setMethod('GET')
            .setSignificance(Significance.Invisible)
            .setErrorHandler(ErrorHandler.None)
            .build()
            .send();
    }

    public async getGlobalSettings(): Promise<GlobalSettings> {
        const url = RoutingSymfony.generate(APP_ROUTE.GLOBAL_SETTINGS);
        return new RequestBuilder(GlobalSettingsC)
            .setUrl(url)
            .setSignificance(Significance.Invisible)
            .setMethod('GET')
            .build()
            .send();
    }
}

export default new AppApi();
